import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
const { VITE_BASE_URL } = import.meta.env;

export const homeApi = createApi({
  reducerPath: "homeApi",
  baseQuery: fetchBaseQuery({
    baseUrl: VITE_BASE_URL,
    // Add the custom middleware to the baseQuery
    prepareHeaders: (headers) => {
      headers.set("Accept", "application/json");
      headers.set("Access-Control-Allow-Origin", "*");
      // headers.set("Cache-Control", "no-store");
      headers.set("Cache-Control", "no-cache");
      // headers['Cache-Control'] = 'no-store'; // Also set it here as a fallback
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getPage: builder.query({
      async queryFn(pageUrl, queryApi, extraOptions, baseQuery) {
        const url = VITE_BASE_URL + pageUrl;
        const response = await baseQuery(url);
        const res = response.data;
        if (!res.data) {
          return { data: { title: "Page Not Found" } };
        }

        res.data.pageUrl = url;
        // Return data
        return { data: res.data };
      },
    }),
  }),
});

// Define your API slice
export const createPageApi = createApi({
  reducerPath: "createPageApi",
  baseQuery: fetchBaseQuery({ baseUrl: VITE_BASE_URL }),
  endpoints: (builder) => ({
    // New endpoint for POST request
    createPage: builder.mutation({
      query: (data) => ({
        url: VITE_BASE_URL + "/api/v1/contact-form/submitContactForm",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const { useGetPageQuery } = homeApi;

export const { useCreatePageMutation } = createPageApi;
